const API_BASE_URL = "https://api.ipaisa.co.in/myapp";

/**
 * Fetches the list of countries.
 */
export const fetchCountries = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/countries/list`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
            },
        });
        const data = await response.json();
        if (data.Status.Code === 200) {
            return data.CountryList;
        }
        throw new Error("Failed to fetch countries");
    } catch (error) {
        console.error("Error fetching countries:", error);
        return [];
    }
};

/**
 * Fetches the list of cities for a given country code.
 * @param {string} countryCode - The country code (e.g., 'IN' for India)
 */
export const fetchCities = async (countryCode) => {
    try {
        const response = await fetch(`${API_BASE_URL}/cities/list`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
            },
            body: JSON.stringify({ CountryCode: countryCode }),
        });
        const data = await response.json();
        if (data.Status.Code === 200) {
            return data.CityList;
        }
        throw new Error("Failed to fetch cities");
    } catch (error) {
        console.error("Error fetching cities:", error);
        return [];
    }
};

/**
 * Fetches the list of hotels for a given city.
 * @param {string} cityCode - The city code.
 * @param {number} page - The current page number for pagination.
 */
export const fetchHotels = async (cityCode, page) => {
    try {
        const response = await fetch(`${API_BASE_URL}/hotels/list`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
            },
            body: JSON.stringify({ CityCode: cityCode, Page: page }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        console.log(response);
        const data = await response.json();
        console.log("Fetched hotels:", data);


    }
    catch (error) {
        console.error("Error fetching hotels:", error);
        return [];
    }
}